import React from "react"
import { AnimationTypes } from "../Animate/Animate"
import { GenericDropDown } from "../Dropdown/Dropdown"
import { ELanguagens } from "../../Enum/ELanguagens"
import { useTranslation } from "react-i18next"

export const ChangeLanguage: React.FC = () => {
  const { i18n } = useTranslation()

  return (
    <div style={{ width: "auto" }}>
      <GenericDropDown
        animationDuration="1.5s"
        animationTypes={AnimationTypes.fadeIn}
        initialState={i18n.language}
        data={Object.mapEnumToStrings(ELanguagens)}
        handlerFuncion={(e) => i18n.changeLanguage(e.target.value)}
        descriptionKey="interactionDescriptions:components.changeLanguage.changeLanguage.select.select"
      />
    </div>
  )
}
